import { ForecastItem } from '../redux/accounting/definitions';

export const isForecastItem = (data: any): data is ForecastItem =>
  typeof data === 'object' &&
  typeof data.instituteScholarship === 'number' &&
  typeof data.entityScholarship === 'number' &&
  typeof data.projects === 'number' &&
  typeof data.invoices === 'number';
